export default __webpack_public_path__ + "static/media/qu.d09ed373.svg";